import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BuiltToLast from "./sections/BuiltToLast";
import OurRemodelingExpertise from "./sections/OurRemodelingExpertise";
import WhyNeighborsTrustFinelyDone from "./sections/WhyNeighborsTrustFinelyDone";
import LocalServiceAreas from "./sections/LocalServiceAreas";
import HomeownerSuccessStories from "./sections/HomeownerSuccessStories";
import YourFirstStepTowardChange from "./sections/YourFirstStepTowardChange";
import QuickContactSiteInfo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BuiltToLast />
      <OurRemodelingExpertise />
      <WhyNeighborsTrustFinelyDone />
      <LocalServiceAreas />
      <HomeownerSuccessStories />
      <YourFirstStepTowardChange />
      <QuickContactSiteInfo />
    </div>;
}